import { use } from "react";
import { UserContext } from "../UserContext.ts";
import { useLoggedInUser } from "./useLoggedInUser.ts";

/**
 * Die Rollen kommen aus `user.read/self`, nicht aus dem localStorage. Der
 * localStorage hält sie weiterhin, aber nur um `useLoggedInUser` überhaupt
 * anzustossen — als Berechtigungsquelle wäre er wertlos: wer sich dort
 * `admin` einträgt, sähe sonst den Verwaltungsbereich, dessen Aufrufe dann
 * mit 403 scheitern. Das Backend prüft ohnehin das JWT; hier geht es darum,
 * dass die Oberfläche nicht lügt.
 */
export const useHasRole = (role: string): boolean | undefined => {
  const userContext = use(UserContext);
  const user = useLoggedInUser();

  /**
   * Ohne gespeicherte Nutzer-ID läuft die self-Query nicht (`enabled`), und
   * eine deaktivierte Query meldet in TanStack Query dauerhaft `isPending`.
   * Ohne diesen Zweig gäbe der Hook für einen nicht angemeldeten Besucher
   * ewig `undefined` zurück — und `useForwardIfNotHasRole`, das nur bei
   * `false` navigiert, würde nie greifen. Genau das war vorher der Fall:
   * `/kommission` und `/bewerbung` zeigten Fremden ihre leere Seitenhülle.
   */
  if (!userContext.userData.userId) {
    return false;
  }

  if (user.isPending) {
    return undefined;
  }

  return user.data?.roles.includes(role) ?? false;
};
